import { call } from 'redux-saga/effects'

import { postApi } from '../helpers/fetchApi'

const endpoint = '/product-api/bazaar-voice-feedback-service'

function* bazaarVoiceFeedbackSaga(action) {
  const { payload } = action

  yield call(postApi, endpoint, {}, payload)
}

export { bazaarVoiceFeedbackSaga, endpoint }
